export default __webpack_public_path__ + "f47a43c28ccaee4ba16d3c6b3dfb6452.json";